import "./styles.css";
import "./curve-styles.css";
import Container from "@material-ui/core/Container";
import { Helmet } from "react-helmet";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import CodeIcon from "@mui/icons-material/Code";
import PagesIcon from "@mui/icons-material/Pages";
import ScienceIcon from "@mui/icons-material/Science";
import LinkIcon from "@mui/icons-material/Link";
import Wand from "./assets/magicwand.png";

import ethcomp from "./assets/ethcompsmall.gif";
import me from "./assets/square pfp.png";
import msu from "./assets/msuwebsitelogo.png";
import slot from "./assets/slot.webp";
import vault from "./assets/vault.png";
import vault2 from "./assets/vault23.png";
import bnb from "./assets/Binance-Coin-BNB-icon.png";
import eth from "./assets/Ethereum-icon-purple.svg.png";
import tether from "./assets/tether-usdt-logo-FA55C7F397-seeklogo.com.png";
import usdc from "./assets/usd-coin-usdc-logo (1).png";
import dai from "./assets/multi-collateral-dai-dai-logo (1).png";
import cake from "./assets/7186.png";
import binanceBull from "./assets/binancebull.png";
import SplitEstate from "./assets/splitEstate.webp";
import AA from "./assets/soberRewards.webp";
import ticketjamlogo from "./assets/ticketjam.png";
import SAAVE from "./assets/ghostmascot.png";
import cyberhunt from "./assets/templogo.png";
import mythicalcreature from "./assets/mythicalcreature.avif";
import hologram from "./assets/hologram.png";
import wallpaper from "./assets/blockwallpaper.jpg";
import pumpkin from "./assets/pumpkinlogo.png"
import pfp from "./assets/gaslimit_pfp.jpg";
import hiPotion from "./assets/Hi-Potion_KHIII.webp";
import blueRhapsody from "./assets/Blue_Rhapsody_KH.png";

import { useState } from "react";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

export default function App() {
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const windowWidth = window.innerWidth;

  const handleSubmit = () => {
    const dateSent = new Date().toLocaleString(); // Captures current date and time

    database
      .collection("form_data")
      .add({
        name: name,
        contact: contact,
        message: message,
        dateSent: dateSent, // Adding the dateSent field
      })
      .then(() => {
        setSubmitted(true);
        console.log("Form data submitted successfulllly!");
        console.log("Submitting:", { name, contact, message, dateSent }); // Debugging line
      })
      .catch((error) => {
        console.error("Error submitting form data:", error);
      });
  };

  const firebaseConfig = {
    apiKey: "AIzaSyCOKRR_Ibfa4_OBoDqD44AinjF2nw98feE",
    authDomain: "portfolio-5e103.firebaseapp.com",
    projectId: "portfolio-5e103",
    storageBucket: "portfolio-5e103.appspot.com",
    messagingSenderId: "493599749646",
    appId: "1:493599749646:web:8cddf1b90b1ca3aaccee5f",
    measurementId: "G-S81620HKEQ",
  };

  firebase.initializeApp(firebaseConfig);

  const database = firebase.firestore();

  const [showContact, setShowContact] = useState(false);

  function showContact1() {
    setShowContact(true);
    console.log(showContact);
  }

  function doesntDoAnything() {
    window.alert("This doesn't do anything.");
  }

  if (!showContact) {
    return (
      <>

        <div className="navBar">
       
          <div className="hamburger" onClick={() => doesntDoAnything()}>
            <i class="fa fa-bars" style={{ color: "yellow" }}></i>
          </div>
        
          <a href="/">
            <div
              className="navItem"
              style={{ backgroundColor: "blue", color: "white" }}
            >
              Home
            </div>
          </a>
          <a href="https://github.com/gas-limit">
            <div className="navItem">Github</div>
          </a>
          <a>
            <div className="navItem" onClick={showContact1}>
              Contact
            </div>
          </a>

          <div className="navItem" onClick={() => doesntDoAnything()}>?</div>
        </div>
        <div className="background">
          <Helmet>
            <style>{"body { background-color: #A5A4CE; }"}</style>
          </Helmet>
          <Container maxWidth="sm">
            <div className="titleBox" style={{ marginBottom: "-20px" }}>
              <div className="innerBorder1">
                <div className="innerBorder2">
                  <img
                    src={blueRhapsody}
                    className="profilePic"
                    style={{ marginTop: "35px", borderRadius: "50%" }}
                  />
                  GAS_LIMIT
                  <br />
                  <div style={{ fontSize: "18px" }}>
                    Smart Contract Developer
                  </div>
                </div>
              </div>
            </div>

            <div className="titleBox" style={{ marginBottom: "-20px", height: windowWidth <= 375 ? "90px" : "80px",  }}>
              <div className="innerBorder1" style={{height:"85%"}}>
                <div className="innerBorder2" style={{height:"85%"}}>
           
                  <div style={{fontSize:"14px", marginTop:"24px", marginRight: windowWidth <= 375 ? "10px" : ""}}> Welcome to my site! I love writing Solidity. </div>
                 
                </div>
              </div>
            </div>

            <div
              className="titleBox"
              style={{
                background: "#C0C0C0",
                marginBottom: "-20px",
                height: windowWidth <= 375 ? "540px" : "470px",
              }}
            >
              <div className="innerBorder1" style={{ height: "98.0%" }}>
                <div className="innerBorder2" style={{ height: "98.0%" }}>
                  <fieldset
                    style={{
                      marginTop: "10px",
                      marginLeft: "20px",
                      marginRight: "20px",
                      height: windowWidth <= 375 ? "420px" : "400px",
                    }}
                  >
                    <legend
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontFamily: "monospace",
                      }}
                    >
                      Services
                    </legend>
                    <div
                      style={{
                        textAlign: "left",
                        color: "black",
                        // fontFamily: "monospace",
                        fontSize: "15px",
                        paddingTop: "0px"
        
                      }}
                    >
                      <div className="highlight">
                        {" "}
                        <img src={hiPotion}  style={{maxHeight: "50px"}}/>
                        <b> Yield Farms </b> Deploy strategies, integrate with AMMs, oracles, and lending protocols.
                        {/* Tokens, DEXs, DAOs, cross-chain, yield vaults, P2P lending, stablecoins, account abstraction, indexes, gambling, bridges  */}
                      </div>
                      <div className="highlight">
                        {" "}
                        <img src={"https://i.ibb.co/zm2tFnp/pngkey-com-moogle-png-2303830.png"} style={{maxHeight: "50px"}}/>
                        <b> Derivatives </b> Leveraged positions, options, futures, perpetual swaps, synthetic assets, prediction markets and more.
                      </div>
                      <div className="highlight">
                        {" "}
                        <img src={"https://kh.wiki.gallery/images/d/da/Defender_%28Shield%29_KH.png"} style={{maxHeight: "50px"}}/>
                        <b> Forks </b> Clone, modify, and deploy existing contracts.
                      </div>
                      <div className="highlight">
                        {" "}
                        <img src={"https://kh.wiki.gallery/images/e/eb/Recipe_KHII.png"} style={{maxHeight: "50px"}}/>
                        <b> Testing </b> Unit, integration, and end-to-end testing using Foundry and Hardhat.
                      </div>
                      
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>

            {/* <div
              className="titleBox"
              style={{ background: "#C0C0C0", marginBottom: "-20px", height: windowWidth <= 375 ? "190px" : "170px" }}
            >
              <div className="innerBorder1">
                <div className="innerBorder2">
                  <fieldset
                    style={{
                      marginTop: "10px",
                      marginLeft: "20px",
                      marginRight: "20px",
                      height: windowWidth <= 375 ? "120px": "100px",
                    }}
                  >
                    <legend
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontFamily: "monospace",
                      }}
                    >
                      Education
                    </legend>
                    <div
                      style={{
                        color: "black",
                        // fontFamily: "monospace",
                        fontSize: "15px",
                        paddingTop: "0px",
                      }}
                    >
                      <b>
                        {" "}
                        <img
                          src="https://ih1.redbubble.net/image.2728415538.1270/poster,504x498,f8f8f8-pad,600x600,f8f8f8.jpg"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                          }}
                        />{" "}
                        Bachelor of Science in Information Technology
                      </b>
                    </div>
                    <div
                      style={{
                        color: "black",
                        paddingTop: "10px",
                        // fontFamily: "monospace",
                        fontSize: "15px",
                      }}
                    >
                      Montclair State University
                    </div>
                    <div
                      style={{
                        color: "black",
                        paddingTop: "20px",
                        // fontFamily: "monospace",
                        fontSize: "15px",
                      }}
                    >
                      Graduation expected:{" "}
                      <div
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          display: "inline",
                        }}
                      >
                        Dec 2023
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div> */}

            {/* <div className="titleBox" style={{background: "#C0C0C0", marginBottom:"-20px"}}>
          <div className="innerBorder1">
            <div className="innerBorder2">

          <fieldset style={{marginTop: "10px", marginLeft:"20px", marginRight: "20px", height:"110px"}}>
            <legend style={{color:"black", fontSize: "14px", fontFamily:"monospace"}}>Work Experience</legend>
            <div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://icodrops.com/wp-content/uploads/2021/11/Curvance_logo-150x150.jpeg" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b>  Curvance</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Internship
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Immersed in a sophisticated DeFi codebase featuring cutting-edge technologies. Shadowed top industry professionals and engineers to gain valuable insights.  
</div>



</div>




          </fieldset>



          </div>
        </div>
        </div> */}

            {/* <div
              className="titleBox"
              style={{
                background: "#C0C0C0",
                marginBottom: "-20px",
                height: windowWidth <= 375 ? "700px" : "210px",
              }}
            >
              <div className="innerBorder1" style={{}}>
                <div className="innerBorder2">
                  <fieldset
                    style={{
                      marginTop: "10px",
                      marginLeft: "20px",
                      marginRight: "20px",
                      height: windowWidth <= 375 ? "220px" : "140px",
                    }}
                  >
                    <legend
                      style={{
                        color: "black",
                        fontSize: "14px",
                        // fontFamily: "monospace",
                      }}
                    >
                      Organizations
                    </legend>
                    <div
                      className="highlight"
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        <div style={{ textAlign: "left", marginTop: "10px" }}>
                          <img
                            src="https://i.ibb.co/9wY4hxV/metalliclogoshadow.png"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              position: "absolute",
                            }}
                          />
                          <div
                            style={{
                              // fontFamily: "monospace",
                              fontSize: "15px",
                              marginLeft: "37px",
                            }}
                          >
                            <b> DTG USA</b>
                            <br />
                            <div
                              style={{ marginLeft: "0px", fontSize: "14px" }}
                            >
                              Chief Technical Officer
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          fontSize: "14px",
                          width: "60%",
                          paddingLeft: "20px",
                          // fontFamily: "monospace",
                        }}
                      >
                        At Digital Transformation Group, our mission is to drive sustainable economic growth by harnessing innovative and inclusive technologies. We aim to build accessibility to empower individuals and businesses to thrive in the digital age.
                      </div>
                    </div>
                    <br/>
                                        <div
                      className="highlight"
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        <div style={{ textAlign: "left", marginTop: "10px" }}>
                          <img
                            src="https://i.ibb.co/n0JhJjj/NEMSUSEXY1.png"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              position: "absolute",
                            }}
                          />
                          <div
                            style={{
                              // fontFamily: "monospace",
                              fontSize: "15px",
                              marginLeft: "37px",
                            }}
                          >
                            <b> Web3 MSU</b>
                            <br />
                            <div
                              style={{ marginLeft: "0px", fontSize: "14px" }}
                            >
                              President
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          fontSize: "14px",
                          width: "60%",
                          paddingLeft: "20px",
                          // fontFamily: "monospace",
                        }}
                      >
                        Organization for students interested in Financial
                        Technology, Blockchain & Crypto. We conduct extra
                        curricular research projects and support for courses
                        CSIT 495 & INFO 492.
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div> */}

            {/* <div className="titleBox" style={{background: "#C0C0C0", height: "1480px", marginBottom:"-50px"}}>
          <div className="innerBorder1" style={{height:"99.3%"}}>
            <div className="innerBorder2" style={{height:"99.2%"}}>

          <fieldset style={{marginTop: "10px", marginLeft:"20px", marginRight: "20px", height:"1400px"}}>
            <legend style={{color:"black", fontSize: "14px", fontFamily:"monospace"}}>Projects</legend>
            <div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://icons.iconarchive.com/icons/icojoy/maneki-neko/512/cat-5-icon.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Neko Decentralized Exchange</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Full Stack Smart Contract Developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Constructed smart contract and game interface that allows users to
              interact with the NEKO Decentralized Exchange ecoystem in order to
              generate revenue to be donated to cat charity foundations through
              the swapping of tokens, and fees accrued through interest bearing
              tokens deposited into vaults by users.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://thetafans.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fpatreon-hero-illustration.a8dc3a3f.png&w=640&q=75" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Theta Fans [🏆Theta Blockchain 2023 Winner] </b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Full Stack Smart Contract Developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Constructed smart contract that allows users to post video content using the Theta Blockchain video API, get paid from subscribers through membership tiers, and facilitate monthly payments.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://t3.ftcdn.net/jpg/03/26/05/04/360_F_326050462_RAeliBpmr6n4QOtjhmOGW7oWlZOX7ZEP.jpg" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Lion Bridge [🏆LionHack 2023 Winner]</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Full-Stack Smart Contract Developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Constructed smart contract and frontend that allows users to bridge tokens from one EVM chain to another EVM chain using the Axelar network. The contract enables users to swap tokens and liquidity providers to earn fees.

</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://thumbs.dreamstime.com/b/halloween-pumpkin-icon-cartoon-style-jack-o-lantern-object-isolated-black-background-can-be-used-your-design-gree-78607366.jpg" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Pumpkin Index [🏆Fantom Q1 2023 Hackathon Winner </b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Smart Contract Developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
An index token platform inspired by Set Protocol, on the Fantom network that allows anyone to customize their own index tokens, rebalance each portion of underlying assets using the Spookyswap exchange, issue/redeem tokens, and collect a streaming fee.
</div>



</div>


<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-tyktyr.netlify.app/static/media/ghostmascot.23b7db5e.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> SAAVE Finance [🏆EthForAll Hackathon Winner]</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Smart Contract Engineer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Yield Aggregator platform that focuses on fees generated from stablecoin vaults. Uses external protocols such as Curve Finance, AAVE, Compound and more.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://cdn1.iconfinder.com/data/icons/bitcoins-1-5/65/35-512.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> TicketJam</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Full Stack Smart Contract Engineer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Led team to create a powerful smart contract protocol which facilitates all financial processes for paid events, from ticket sales to event payouts and guest check in. The protocol is designed to be flexible and can be used for any type of event, from concerts to conferences.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-376mrj.netlify.app/static/media/slot.809c86d6.webp" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> ERC20 Slot Machine </b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Smart Contact Developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Built Slot Machine gambling game that awards a variety of digital assets as prizes Utilized Oracle Chainlink’s VRFv2 (Verifiably Random Function) to produce verifiably random games Secured using blockchain technology.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-tyktyr.netlify.app/static/media/binancebull.88d46900.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Binance Bull🐂 Vault</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Smart Contract Engineer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Built yield vault that starts off on the Ethereum Blockchain, user funds are bridged to the Binance Smart Chain using the Stargate protocol, and provides liquidity to PancakeSwap's CAKE/BNB pool pair.
</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-376mrj.netlify.app/static/media/vault23.fc4a5084.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> ETH Super Staker⭐ Vault</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Smart Contract Engineer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Built yield vault that stakes ether on Rocketpool, provides WETH & rETH liquidity pair to Balancer protocol.
</div>



</div>



          </fieldset>



          </div>
        </div>
        </div> */}

            <br />

            <br />

            <br />

            {/* <div className="titleBox" style={{background: "#C0C0C0", height: "350px"}}>
  <div className="innerBorder1" style={{height: "97%"}}>
    <div className="innerBorder2" style={{height: "97%"}}>
    <fieldset style={{marginTop: "10px", marginLeft:"20px", marginRight: "20px", height:"280px"}}>
      <legend style={{color:"black", fontSize: "14px", fontFamily:"monospace"}}>
          Other Work
        </legend>

        <div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-tyktyr.netlify.app/static/media/templogo.fbb499c9.png" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Cyberhunt NFT</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Front end developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Developed React website on AWS, enabling user whitelist with Merkle Tree encryption and Web3 read/write to Ethereum Mainnet's "Token Burn" smart contract. Facilitated secure and seamless transactions via cryptocurrency wallets.

</div>



</div>

<div className="highlight" style={{display:"flex", justifyContent:"space-evenly"}}>
            <div>
            <div style={{textAlign:"left", marginTop:"10px"}}>
            <img src="https://csb-tyktyr.netlify.app/static/media/mythicalcreature.298f318e.avif" style={{width:"30px", height: "30px", borderRadius: "50%", position:"absolute"}}/>
            <div style={{fontFamily:"monospace", fontSize:"15px", marginLeft:"37px"}}>
  <b> Mythical Creatures NFT</b>
<br/>
  <div style={{marginLeft:"0px", fontSize:"14px"}}>
  Front end developer
  </div>
</div>
</div>
</div>

<div style={{fontSize:"14px", width:"60%", paddingLeft:"20px"}}>
Developed React website on AWS with Merkle Tree encryption to whitelist users and enabled Web3 read/write to Ethereum Mainnet's "Phantom Staking" ERC721L contract. Ensured secure and seamless transactions through cryptocurrency wallets.
</div>



</div>


      </fieldset>
    
  </div>
  </div>
  </div> */}

            <br />

            {/* <div className="containerBox">
    <div className="category">
            <h3> Testimonials </h3>
          </div>


          <br/>
 

      <div className="center">

          <br/>
          <br/>
            
            <div className="projectDescription">
              <div className="projTitle"> Mai </div>
              Lead Engineer at Curvance
            </div>
            
        </div>

<br/>

        <div className="center">


<br/>
  
  <div className="projectDescription">
    <div className="projTitle"> Thomas Zakrzewski
 </div>
 KatalX - Chief Product & Technology Officer / Co-Founder
  </div>
  
</div>

      </div> */}
          </Container>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="navBar">
          <div className="hamburger" onClick={() => doesntDoAnything()}>
            <i class="fa fa-bars" style={{ color: "yellow" }}></i>
          </div>
          <a href="/">
            <div className="navItem">Home</div>
          </a>
          <a href="https://github.com/gas-limit">
            <div className="navItem">Github</div>
          </a>
          <a>
            <div
              className="navItem"
              onClick={showContact1}
              style={{ backgroundColor: "blue", color: "white" }}
            >
              Contact
            </div>
          </a>

          <div className="navItem" onClick={() => doesntDoAnything()}>?</div>
        </div>

        {submitted && <div className="popupBackground"></div>}

        {submitted && (
          <div className="popup">
            <div
              style={{ display: "inline", color: "yellow", cursor: "pointer" }}
            >
              S
            </div>
            uccessfully sent a message, I will get back to you as soon as
            possible.
          </div>
        )}

        <div className="background">
          <Helmet>
            <style>{"body { background-color: #A5A4CE; }"}</style>
          </Helmet>
          <Container maxWidth="sm">
            <div className="titleBox" style={{ marginBottom: "-20px" }}>
              <div className="innerBorder1">
                <div className="innerBorder2">
                  <img
                    src={blueRhapsody}
                    className="profilePic"
                    style={{ marginTop: "35px", borderRadius: "50%" }}
                  />
                  GAS_LIMIT
                  <br />
                  <div style={{ fontSize: "18px" }}>
                    Smart Contract Developer
                  </div>
                </div>
              </div>
            </div>

            <div
              className="titleBox"
              style={{ background: "#C0C0C0", height: "520px" }}
            >
              <div className="innerBorder1" style={{ height: "97.9%" }}>
                <div className="innerBorder2" style={{ height: "97.8%" }}>
                  <fieldset
                    style={{
                      marginTop: "10px",
                      marginLeft: "20px",
                      marginRight: "20px",
                      height: "450px",
                    }}
                  >
                    <legend
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontFamily: "monospace",
                      }}
                    >
                      Contact me
                    </legend>
                    <div
                      style={{
                        color: "black",
                        fontFamily: "monospace",
                        fontSize: "15px",
                        textAlign: "left",
                      }}
                    >
                      <b>1. Name</b>
                      <br />
                      <br />
                      <input
                        type="text"
                        style={{ background: "blue", color: "white" }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <br />
                      <br />
                      <b>2. Contact Information</b>
                      <br />
                      <br />
                      <input
                        type="text"
                        style={{ background: "blue", color: "white" }}
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                      />
                      <br />
                      <br />
                      <b>3. Message</b>
                      <br />
                      <br />
                      <textarea
                        type="text"
                        style={{
                          background: "blue",
                          color: "white",
                          height: "150px",
                          width: windowWidth <= 375 ? "95%" : "300px",
                        }}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>
                      <br />
                      <br />
                      <div
                        className="button"
                        style={{
                          marginLeft: "0px",
                          marginTop: "0px",
                          fontSize: "15px",
                          maxWidth: "80px",
                          fontFamily: "monospace",
                          color: "white",
                          textAlign: "center",
                          backgroundColor: "#808080",
                          cursor: "pointer",
                        }}
                        onClick={handleSubmit}
                        disabled={submitted}
                      >
                        <div style={{ display: "inline", color: "yellow" }}>
                          S
                        </div>
                        end
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            
            
          </Container>
        </div>
      </>
    );
  }
}
